// Static before/after comparison: displays a single source image
// where before/after are already side-by-side or stacked.
// layout: "stacked" (top=before, bottom=after) | "sideBySide" (left=before, right=after)
export default function BeforeAfterSlider({ src, layout = "sideBySide", alt = "Before and after" }) {
    const isStacked = layout === "stacked";
    return (
        <div
            data-testid="before-after-static"
            className="relative w-full overflow-hidden select-none bg-nude border border-champagne/20"
        >
            <img
                src={src}
                alt={alt}
                className="w-full h-auto block"
                loading="lazy"
                draggable={false}
            />
            {/* Before label */}
            <div
                className={`absolute eyebrow text-bone bg-ink/70 backdrop-blur-sm px-3 py-1.5 ${
                    isStacked ? "top-4 left-4" : "top-4 left-4"
                }`}
            >
                Before
            </div>
            {/* After label */}
            <div
                className={`absolute eyebrow text-bone bg-champagne/90 px-3 py-1.5 ${
                    isStacked ? "bottom-4 right-4" : "top-4 right-4"
                }`}
            >
                After
            </div>
            {/* Divider line */}
            {isStacked ? (
                <div className="absolute inset-x-0 top-1/2 h-px bg-bone/60 shadow-[0_0_12px_rgba(0,0,0,0.3)]" />
            ) : (
                <div className="absolute inset-y-0 left-1/2 w-px bg-bone/60 shadow-[0_0_12px_rgba(0,0,0,0.3)]" />
            )}
        </div>
    );
}
